import routes from './routes';
import { SetRoutes } from 'components';

const LogsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default LogsPages;
